import React, { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";

type ProductImageGalleryProps = {
  images: string[];
  productName: string;
};

export const ProductImageGallery = ({ images, productName }: ProductImageGalleryProps) => {
  const [nav1, setNav1] = useState<Slider>();
  const [nav2, setNav2] = useState<Slider>();
  const slider1 = useRef<Slider>(null);
  const slider2 = useRef<Slider>(null);

  useEffect(() => {
    if (slider1.current) setNav1(slider1.current);
    if (slider2.current) setNav2(slider2.current);
  }, []);

  // --- SỬA Ở ĐÂY ---
  const mainSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: nav2,
    autoplay: true,
    autoplaySpeed: 3000, // Bạn có thể thay đổi tốc độ ở đây
  };

  const thumbSliderSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: nav1,
    dots: false,
    arrows: images.length > 4,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
  };

  return (
    <div className="product-gallery">
      <Slider {...mainSliderSettings} ref={slider1}>
        {images.map((img, index) => (
          <div key={index} className="w-full h-[400px] bg-white p-4">
  <img src={img} alt={`${productName} - ảnh ${index + 1}`} className="w-full h-full object-contain" />
</div>
        ))}
      </Slider>

      <div className="mt-4 thumbnail-slider">
        <Slider {...thumbSliderSettings} ref={slider2}>
          {images.map((img, index) => (
            <div key={index} className="p-1">
              <div className="h-24 border-2 border-transparent hover:border-green-500 p-1 cursor-pointer bg-white">
                 <img src={img} alt={`thumbnail ${index + 1}`} className="w-full h-full object-contain" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};